import {forwardRef} from 'react';
import {DetailedProps, join} from '../../utils';
import {Box} from '../box/box';

import styles from './list.module.less';

export type ListProps = DetailedProps<HTMLDivElement>;

export const List = forwardRef<HTMLDivElement, ListProps>(({className, ...props}, ref) => {
	return <Box role='list' className={join(styles.list, className)} ref={ref} {...props}/>;
});

export default List;
